import { RouteObject } from 'react-router-dom'

import { DefaultsPage } from 'features/globalSetup/pages/Defaults/DefaultsPage'
import AuthorizedRoute from 'providers/router/components/AuthorizedRoute'
import { ROUTES } from 'routes'

export const defaultsRoutes: RouteObject[] = [
  {
    element: (
      <AuthorizedRoute
        access='GlobalSetupPage-defaults-prebid'
        page={<DefaultsPage />}
      />
    ),
    path: ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT,
  },
]
